import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Layout from '../Layout/Layout';

export default function Loading() {
  return (
    <Layout plain>
      <h4 className="mt-5">
        <FontAwesomeIcon icon={faSpinner} spin pulse className="text-muted" />{' '}
        Loading...
      </h4>
      <p className="mt-5 small text-muted">
        If you feel this process is taking some time,{' '}
        <a href="/admin/">click here</a> to refresh the validation.
      </p>
    </Layout>
  );
}
